<script>
  import { onMount } from "svelte";
  import SuitabilityChoice from "./SuitabilityChoice.svelte";
  import ModelInputs from "./ModelInputs.svelte";
  import ResultChoice from "./ResultChoice.svelte";
  import { Tooltip, tooltip } from "@svelte-plugins/tooltips";
  import * as ss from "simple-statistics";
  import { radioCheck, topZonesStore } from "../store";
  export let map;
  let topZones = 0;
  let click = 0;
  $: changeTopZones(topZones);

  function changeTopZones(tz) {
    if (map) {
      if (tz == 0) {
        $topZonesStore = topZones;
        map.setPaintProperty("box-layer", "fill-opacity", 0.8);
      } else {
        if (document.getElementById("arrow").innerHTML == "▲" && click == 0) {
          document.getElementById("arrow").click();
          click = click + 1;
        }

        var data = map.getSource("box")._data.features;
        const values = data.map((obj) => obj.properties[$radioCheck]);
        values.sort((a, b) => a - b);
        var tz = 1 - topZones / 100;
        var top10 = ss.quantile(values, [0, tz, 1]);
        $topZonesStore = topZones;
        map.setPaintProperty("box-layer", "fill-opacity", [
          "case",
          [">=", ["get", $radioCheck], top10[1]],
          0.8,
          0.1,
        ]);
      }
    }
  }
  onMount(() => {});
</script>

<div class="leftMenu">
  <img
    src="/img/Title.png"
    alt="title"
    style="    position: relative;
    top: -210px;
    left: -724px;
    scale: 0.15;"
  />

  <br />
  <div style="position: relative;    top: -440px;">
    <div class="suitChoice">
      <h4 style="color:white;margin:15px;font-weight:500">
        Do you want to see:
      </h4>
      <SuitabilityChoice {map} />
    </div>
    <div class="inputChoice">
      <h4 style="color:white;margin:15px;font-weight:500">Choose your map:</h4>

      <ModelInputs {map} />
    </div>
    <div class="leftMenuExtras">
      <div class="slidecontainer" style="margin: 15px;">
        <div style="margin:15px">
          <p>
            <span
              use:tooltip={{
                content:
                  "<span style='font-size:11px'> These are the most suitable locations – you can view the top 5% to 50%. We recommend selecting: <ul><li>For urban areas (cities and towns), it is recommended to view the top 50%</li>        <li>For semi-urban areas (rural town and urban fringes) the top 30%</li><li>For rural areas (village and dispersed), the top 10%</li></ul></span>",
                position: "top",
                autoPosition: true,
                style: {
                  backgroundColor: "gray",
                },
              }}
              style="position: relative;
    font-size: 0.8em;
    top: -10px;"
            >
              Visualise the most suitable areas for micromobility :</span
            ><span
              id="all"
              style="    text-align: justify;
right: 10px;
top: 45px;
font-weight: 600;
font-size: 22px;
color: #45bcbb;position: absolute;"
            >
              {#if $topZonesStore == 0}
                All
              {:else}
                {$topZonesStore}%
              {/if}
            </span>
          </p>

          <input
            id="topZones"
            style="margin-top: -10px;width:80%;padding:0px;accent-color:#45bcbb;position:relative;top:-25px"
            type="range"
            min="0"
            max="50"
            step="5"
            bind:value={topZones}
          />
        </div>
      </div>

      <!-- <div class="resultChoice">
        <h4 style="color:white;margin:15px;font-weight:500">
          Calculate Insights:
        </h4>
        <ResultChoice {map} />
      </div>-->
    </div>
  </div>
</div>

<style>
  .leftMenuExtras {
    opacity: 0;
    transition: opacity ease 0.5s;
  }
  .leftMenu {
    opacity: 100%;
    height: 335px;
    width: 280px;
    position: absolute;
    z-index: 10000;
    background-color: black;
    border-radius: 5px;
    font-family: Poppins;
    color: white;
    transition: height ease 0.5s;
  }
  img {
    position: absolute;
    top: 33px;
    right: 0px;
  }

  h2 {
    margin-bottom: -30px;
    padding: 0;
  }
  .suitChoice {
    position: relative;
    margin: 15px;
    width: calc(100% - 30px);
    height: 100px;
    border-radius: 10px;
    background-color: #1c3444;
    border: 1px solid white;
  }
  .slidecontainer {
    position: relative;
    margin: 15px;
    width: calc(100% - 30px);
    height: 85px;
    border-radius: 10px;
    background-color: #1c3444;
    border: 1px solid white;
  }
  .inputChoice {
    position: relative;
    margin: 15px;
    width: calc(100% - 30px);
    height: 100px;
    border-radius: 10px;
    background-color: #1c3444;
    border: 1px solid white;
  }
  .resultChoice {
    position: relative;
    margin: 15px;
    width: calc(100% - 30px);
    height: 130px;
    border-radius: 10px;
    background-color: transparent;
    border: 1px solid white;
  }
</style>
